var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"status-chip",style:(_vm.chipStyle)},[(_vm.dot)?_c('span',{staticClass:"status-chip-dot",style:({ background: _vm.color })}):_vm._e(),_vm._t("default",function(){return [_vm._v(_vm._s(_vm.label))]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }